import {Box, Typography} from "@mui/material";
import {c, maxW} from "../landingTokens";

const METRICS = [
  {value: "70", unit: "%", label: "of FAQs resolved with no human help"},
  {value: "<1", unit: "s", label: "to greet a caller — no hold time"},
  {value: "100", unit: "+", label: "customer intents understood out of the box"},
  {value: "24", unit: "/7", label: "multilingual coverage, zero downtime"},
];

export const Metrics = () => (
  <Box component="section" data-screen-label="Metrics" sx={{borderTop: `1px solid rgba(44,43,42,0.1)`, bgcolor: c.bgSoft}}>
    <Box
      sx={{
        maxWidth: maxW,
        mx: "auto",
        px: 2.75,
        py: 9.5,
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
        gap: "44px 30px",
      }}
    >
      {METRICS.map((m) => (
        <Box key={m.label}>
          <Typography sx={{fontSize: "clamp(40px, 5vw, 60px)", fontWeight: 600, letterSpacing: "-0.04em", lineHeight: 1}}>
            {m.value}
            <Box component="span" sx={{color: c.purple}}>{m.unit}</Box>
          </Typography>
          <Typography sx={{fontSize: 14, color: c.inkSoft, mt: 1.5, lineHeight: 1.45}}>{m.label}</Typography>
        </Box>
      ))}
    </Box>
  </Box>
);
